import { render, staticRenderFns } from "./CreateAppSection.vue?vue&type=template&id=b47d2f5a&scoped=true"
import script from "./CreateAppSection.vue?vue&type=script&lang=js"
export * from "./CreateAppSection.vue?vue&type=script&lang=js"
import style0 from "./CreateAppSection.vue?vue&type=style&index=0&id=b47d2f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47d2f5a",
  null
  
)

export default component.exports